import { money } from "../../../../../../../../../../utils/numeral/money";
import { chartCumulativeSeriesName } from "../../../../../../../../../../storybook/c8r-highcharts/common/utils/constants/chartDefaultConfigs";

export const generateBillingExplorerChartCumulativeTooltipMarkup = (
  total: number,
  cumulative: number,
  startDate: string,
  pointDate: string,
) => {
  return `
    <div style="display: flex; align-items: center; border-left: 4px solid #4285F4; padding-left: 8px; border-radius: 2px;">
        <div>
        ${
          total
            ? ` <div style="display:flex; margin-bottom: 6px; gap:8px; justify-content: space-between;">
                  <span style="font-weight: 400; font-size: 12px;">Total (${pointDate})</span><br>
                  <span style="font-weight: 500; font-size: 14px;">${money(total)}</span>
                </div>`
            : ""
        }
         
          <div style="display:flex; margin-bottom: 6px; gap:8px; justify-content: space-between;">
            <span style="font-weight: 400; font-size: 12px;">${chartCumulativeSeriesName} (${startDate} - ${pointDate})</span><br>
            <span style="font-weight: 500; font-size: 14px;">${money(cumulative)}</span>
          </div>
        </div>
    </div>
`;
};
